<!--
 * @Author: 黄昱森
 * @LastEditors: 黄昱森
 * @Description: 
-->
<template>
  <div :class="computedCls">
    <div :class="['lc-narrowBroadBase', navPositionCls]" ref="container">
      <div class="lc-narrowBroadBase__side">
        <div
          v-for="tab in sideTabs"
          :key="tab.name"
          :class="['lc-tabsNav__navBar', activeTabNav === tab.name ? 'lc-tabsNav__navBar-active' : '']"
          @click="handleScrollToAnchor(tab)"
        >
          {{ tab.label }}
        </div>
      </div>
      <div class="lc-narrowBroadBase__main" @scroll="handleScrollMain">
        <div class="scroll-wrapper">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LcTabNav',
  props: {
    value: {
      type: String,
      default: ''
    },
    navPosition: {
      type: String,
      default: 'left'
    },
    theme: {
      type: String,
      default: 'default'
    }
  },
  data() {
    return {
      activeTabNav: '',
    };
  },
  computed: {
    computedCls() {
      return ['lc-tabsNav', `lc-tabsNav-${this.theme}`];
    },
    navPositionCls() {
      return this.navPosition === 'right' ? 'lc-narrowBroadBase-inverse' : ''
    },
    sideTabs() {
      return this.$slots.default.map(pane => {
        return pane.componentOptions.propsData;
      });
    }
  },
  created() {
  },
  mounted() {
    // preset
    this.activeTabNav = this.$slots.default[0].componentInstance.name;
    this.computeLastPaneMgBt();
  },
  methods: {
    handleScrollToAnchor({name}) {
      this.setCurrentName(name)
    },
    setCurrentName(name) {
      this.$slots.default
        .find(pane => pane.componentInstance.name === name)
        .componentInstance.$el.scrollIntoView({ behavior: 'smooth' });
      this.$emit('input', name);
    },
    handleMainScroll(e) {
      const paneList = this.$slots.default.map(pane => pane.componentInstance);
      const mainScrollTop = e.target.scrollTop;
      paneList.forEach(pane => {
        if (Math.abs(mainScrollTop - pane.$el.offsetTop) < 50) {
          this.activeTabNav = pane.name;
          this.$emit('input', pane.name);
        }
      });
    },
    computeLastPaneMgBt() {
      setTimeout(() => {
        const containerH = this.$refs['container'].clientHeight;
        const lastPane = this.$slots.default[this.$slots.default.length - 1].elm;
        const lastPaneH = lastPane.clientHeight;
        const marginBottom = containerH - lastPaneH;
        lastPane.style.marginBottom = marginBottom + 'px';
      });
    }
  }
};
</script>